import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Jobs from "@/pages/admin/Jobs";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/jobs/")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-jobs", path: "/admin/jobs", title: "Cloud Admin Jobs", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Jobs /></AdminLayout>,
});
